







































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";

import Detail from "./reconciliationdetail.vue";

@Component({
  components: {
    Detail
  }
})
export default class extends Mixins(MyList) {
  @Prop() mobile!: string;

  detailModalVisible = false;

  oldData!: any;

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "用户名称",
      dataIndex: "username"
    },
    { title: "手机号", dataIndex: "mobile" },
    {
      title: "账面平台余额",
      scopedSlots: { customRender: "user_balance_total" }
    },
    {
      title: "账面场馆余额",
      scopedSlots: { customRender: "stadium_balance_total" }
    },
    {
      title: "追账平台余额",
      scopedSlots: { customRender: "user_balance_total_check" }
    },
    {
      title: "追账场馆余额",
      scopedSlots: { customRender: "stadium_balance_total_check" }
    },
    { title: "对账时间", dataIndex: "check_time" },
    { title: "对账结果", scopedSlots: { customRender: "result" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  showDetailModal(record: any) {
    this.oldData = record;
    this.detailModalVisible = true;
  }

  hideDetailModal() {
    this.detailModalVisible = false;
  }

  async loadData1() {
    this.loading = true;
    // console.log(this.mobile)
    const res = await this.$store.dispatch("finance/getReconciliations", {
      search_key: this.mobile
    });
    if (res && res.Data) {
      this.data = res.Data.data;
    }
    this.loading = false;
  }

  mounted() {
    this.loadData1();
  }
}
